export default {
  meta: {
    title: '搜索'
  }
};
